import LoginHistory from "./LoginHistory.vue";

export default {
  path: "/config/login-history",
  name: "LoginHistory",
  component: LoginHistory,
  meta: {
    breadcrumb: "loginHistory"
  }
};
